module.exports = __webpack_public_path__ + "img/endeavor.2e39c401.png";